import { EditOutlined } from "@ant-design/icons";
import { Space, Table, Drawer, Button } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import CustomTableSearch from "../common/CustomTableSearch";















const PurchaseListView = (props) => {
    const [filteredSearchList, setFilteredSearchList] = useState([]);

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);

    useEffect(()=>{
        setFilteredSearchList(props.purchaseList);
    },[props.purchaseList]);

    const onSearch = (e) => {
        setFilteredSearchList([]);
        const string = e.target.value;
        const x = props.purchaseList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
        setFilteredSearchList(x)
      }

    const columns = [
        { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
        {
            title: 'Bill No',
            dataIndex: 'bill_number',
            key: 'bill_number',


        },
        {
            title: 'Bill Date',
            dataIndex: 'billDate',
            key: 'billDate',


        },
        {
            title: 'Vendor',
            dataIndex: 'vendorname',
            key: 'vendorname',


        },
        {
            title: 'Taxable Amt.',
            dataIndex: 'total_taxable',
            key: 'total_taxable',
        },
        {
            title: 'Gst Amt.',
            dataIndex: 'total_gst',
            key: 'total_gst',
        },
        {
            title: 'Total Amt (Inc. GST)',
            dataIndex: 'gst_including_amount',
            key: 'gst_including_amount',
        },
        {
            title: 'Round off',
            dataIndex: 'round_off',
            key: 'round_off',
        },
        {
            title: 'Net Amount',
            dataIndex: 'net_amount',
            key: 'net_amount',
        },
        {
            title: 'Action',
            key: 'action',
            render: (selectedObj) => (

                <Space size="middle">
                    <Link to={`/purchase/entry/${selectedObj.purchase_id}`} >
                        <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
                    </Link>
                </Space>
            ),
        },
    ];




    return (
        <>

            <CustomTableSearch onSearchTable={onSearch} style={{marginBottom: "8px"}} />
            <Table columns={columns} rowKey='purchase_id' dataSource={filteredSearchList} />
        </>
    );
};

export default PurchaseListView